import axios from 'utils/axios';
import { map } from 'lodash';
import { formatDateUTCWithoutTime, formatAsLocalizedDateIgnoringTZ } from 'utils/date';

export async function listCareSuspension(patientId) {
    try {
        const response = await axios.get(`/api/org-id/{orgId}/clinic-id/{clinicId}/patient/${patientId}/care-suspension`);
        return {
            data: {
                ...response.data,
                careSuspensions: map(response.data?.careSuspensions, (suspension) => ({
                    ...suspension,
                    eventStartDate: suspension.eventStartDate
                        ? formatAsLocalizedDateIgnoringTZ(suspension.eventStartDate)
                        : suspension.eventStartDate,
                    eventEndDate: suspension.eventEndDate
                        ? formatAsLocalizedDateIgnoringTZ(suspension.eventEndDate)
                        : suspension.eventEndDate
                }))
            }
        };
    } catch (e) {
        // fetches throw and are caught by store
        if (e && e.statusCode && e.message) {
            throw e;
        }
        throw new Error('unknown error');
    }
}

export async function getCareSuspensionStatus(patientId) {
    try {
        const response = await axios.get(`/api/org-id/{orgId}/clinic-id/{clinicId}/patient/${patientId}/care-suspension/status`);
        return response;
    } catch (e) {
        // fetches throw and are caught by store
        if (e && e.statusCode && e.message) {
            throw e;
        }
        throw new Error('unknown error');
    }
}

export async function createCareSuspension(patientId, data) {
    try {
        const response = await axios.post(`/api/org-id/{orgId}/clinic-id/{clinicId}/patient/${patientId}/care-suspension`, {
            ...data,
            eventStartDate: formatDateUTCWithoutTime(data.eventStartDate),
            eventEndDate: data.eventEndDate ? formatDateUTCWithoutTime(data.eventEndDate) : data.eventEndDate
        });
        return response;
    } catch (e) {
        // writes return the errors
        if (e && e.statusCode && e.message) {
            return e;
        }
        return new Error('unknown error');
    }
}

export async function updateCareSuspension(patientId, careSuspensionId, data) {
    try {
        const response = await axios.post(
            `/api/org-id/{orgId}/clinic-id/{clinicId}/patient/${patientId}/care-suspension/${careSuspensionId}`,
            {
                ...data,
                eventStartDate: formatDateUTCWithoutTime(data.eventStartDate),
                eventEndDate: data.eventEndDate ? formatDateUTCWithoutTime(data.eventEndDate) : data.eventEndDate
            }
        );
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return new Error('unknown error');
    }
}

export async function deleteCareSuspension(patientId, careSuspensionId) {
    try {
        const response = await axios.delete(
            `/api/org-id/{orgId}/clinic-id/{clinicId}/patient/${patientId}/care-suspension/${careSuspensionId}`
        );
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return new Error('unknown error');
    }
}

export async function getCareTimeByEnrollmentWithinWindow(patientId, eventStartDate, eventEndDate) {
    try {
        const response = await axios.get(
            `/api/org-id/{orgId}/clinic-id/{clinicId}/patient/${patientId}/care-session/care-time-within-window`,
            {
                params: {
                    eventStartDate: formatDateUTCWithoutTime(eventStartDate),
                    eventEndDate: eventEndDate ? formatDateUTCWithoutTime(eventEndDate) : eventEndDate
                }
            }
        );
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            throw e;
        }
        throw new Error('unknown error');
    }
}
